/* eslint-disable import/prefer-default-export */
import {
  SEND_EMAIL_POST_REQUEST,
  SEND_EMAIL_POST_SUCCESS,
  SEND_EMAIL_POST_ERROR,
} from 'Redux/types/sendEmailTypes';

import { CALL_ACTIONS } from 'Redux/middleware';
import { BACKEND_URL_QUOTATION } from 'Config/routes';


const postSendEmail = (emails, idQuotation) => (
  {
    [CALL_ACTIONS]: {
      TYPES: [SEND_EMAIL_POST_REQUEST, SEND_EMAIL_POST_SUCCESS, SEND_EMAIL_POST_ERROR],
      ENDPOINT: `${BACKEND_URL_QUOTATION}${idQuotation}/send/`,
      METHOD: 'POST',
      DATA: { emails: emails.toString() },
    },
  });

export const sendEmail = (data) => (dispatch) => dispatch(postSendEmail(data.emails, data.idQuotation));
